<div class="combobox-container">
  <span *ngIf="!searching" class="label"
    >{{ label }}:
    <span class="required-asterisk" *ngIf="required"> *</span></span
  >
  <button
    (click)="showMenu()"
    [ngClass]="searching ? 'hidden' : ''"
    class="value"
    onkeypress="showMenu()"
  >
    {{ choice[key] }}</button
  >
  <input
    aria-label="Search"
    *ngIf="searching"
    (keyup)="onKey($event)"
    type="text"
    [placeholder]="label"
    [(ngModel)]="query"
  />
  <div class="dropdown-container">
    <div class="dropdown">
      <button
        alt="Menu Button"
        (click)="showMenu()"
        onkeypress="showMenu()"
        >
        <svg
          class="value"
          focusable="false"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
        >
          <path
            d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z"
          ></path>
        </svg>
      </button>
    </div>
    <div class="menu" *ngIf="showingMenu && options && options.length">
      <button 
        (click)="select(option)" 
        *ngFor="let option of options"
        onkeypress="select(option)"
        class="menu-option"
      >
        {{ option[key] }}
      </button>
    </div>
  </div>
</div>
